import { useState, useRef, useCallback } from 'react';

const MAX_ONLINE_EVENTS = 10;

export const useOnlinePresence = ({ currentUser }) => {

  const [onlineStatus, setOnlineStatus] = useState({});
  const [onlineEvents, setOnlineEvents] = useState([]);

  const onlineStatusRef = useRef(onlineStatus);

  // Synchronise la ref à chaque changement (appelé depuis useEffect du Screen)
  const syncRef = (val) => { onlineStatusRef.current = val; };

  const pushEvent = (event) =>
    setOnlineEvents((prev) => [event, ...prev].slice(0, MAX_ONLINE_EVENTS));

  /**
   * user.online → connexion / déconnexion
   * Retourne le updater de users → le Screen l'applique sur setUsers
   * car onlinePresence ne possède pas users
   */
  const handleUserOnline = useCallback((data, setUsers) => {
    setOnlineStatus((prev) => {
      const next = { ...prev, [data.user_id]: data.online };
      onlineStatusRef.current = next;
      return next;
    });

    setUsers((prev) => {
      const updated = prev.map((u) =>
        String(u.id) === String(data.user_id)
          ? { ...u, is_online: data.online }
          : u
      );

      const isSelf       = currentUser && String(currentUser.id) === String(data.user_id);
      const shouldNotify = !isSelf &&
        data.notify_admin_ids?.map(String).includes(String(currentUser?.id));

      if (shouldNotify) {
        const found    = prev.find((u) => String(u.id) === String(data.user_id));
        const username = found?.username || `User ${data.user_id}`;
        pushEvent({ user_id: data.user_id, username, online: data.online, timestamp: Date.now() });
      }

      return updated;
    });
  }, [currentUser]);

  /**
   * model.used → simulation SecuFire lancée
   */
  const handleModelUsed = useCallback((data) => {
    if (!currentUser) return;
    if (!data.notify_admin_ids?.map(String).includes(String(currentUser.id))) return;
    pushEvent({
      user_id:   data.user_id,
      username:  data.username,
      online:    true,
      timestamp: Date.now(),
      type:      'simulation',
      message:   `a lancé une simulation (${data.ref})`,
    });
  }, [currentUser]);

  return {
    onlineStatus,
    onlineStatusRef,
    onlineEvents,
    syncRef,
    handleUserOnline,
    handleModelUsed,
  };
};